/**
 * Created by XuQiang on 2017/5/25.
 */
import React, { PureComponent } from 'react';
import { Modal } from 'antd';
import './TestPage.less';
import {
  Chart,
  Geom,
  Tooltip,
  Coord,
  Label,
  View,
} from 'bizcharts';
import DataSet from '@antv/data-set';

class TestPage extends PureComponent {
  static defaultProps = {
  };
  constructor() {
    super();
    this.state = {
    };
  }

  render() {
    const { DataView } = DataSet;
    const data = [
      {
        value: 251,
        type: '取消',
        kind: '手动提前取消',
      },
      {
        value: 251,
        type: '取消',
        kind: '审批未通过取消',
      },
      {
        value: 251,
        type: '取消',
        kind: '第三方同步取消',
      },
      {
        value: 251,
        type: '取消',
        kind: '参会人全部拒绝取消',
      },
      {
        value: 251,
        type: '取消',
        kind: '会议室维护取消',
      },

      {
        value: 434,
        type: '结束',
        kind: '提前结束',
      },
      {
        value: 434,
        type: '结束',
        kind: '红外释放',
      },
      {
        value: 434,
        type: '结束',
        kind: '时间到了结束',
      },
      {
        value: 434,
        type: '结束',
        kind: '延长之后结束',
      },

      {
        value: 610,
        type: '未签到释放',
        kind: '未签到释放',
      }
    ];
    const dv = new DataView();
    dv.source(data).transform({
      type: 'percent',
      field: 'value',
      dimension: 'type',
      as: 'percent',
    });
    const cols = {
      percent: {
        formatter: (val) => {
          val = `${(val * 100).toFixed(2)}%`;
          return val;
        },
      },
    };
    const dv1 = new DataView();
    dv1.source(data).transform({
      type: 'percent',
      field: 'value',
      dimension: 'kind',
      as: 'percent',
    });
    return (
      <div>
        <Chart
          height={window.innerHeight}
          data={dv}
          scale={cols}
          padding={[80, 100, 80, 80]}
          forceFit
        >
          <Coord type="theta" radius={0.5} />
          <Tooltip
            showTitle={false}
            itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{kind}: {value}</li>"
          />
          <Geom
            type="intervalStack"
            position="percent"
            color="type"
            tooltip={[
              'type*percent',
              (item, percent) => {
                percent = `${(percent * 100).toFixed(2)}%`;
                return {
                  kind: item,
                  value: percent,
                };
              },
            ]}
            style={{
              lineWidth: 1,
              stroke: '#fff',
            }}
            select={false}
          >
            <Label content="type" offset={-10} />
          </Geom>
          <View data={dv1} scale={cols}>
            <Coord type="theta" radius={0.75} innerRadius={0.5 / 0.75} />
            <Geom
              type="intervalStack"
              position="percent"
              color={[
                'kind',
                [
                  '#BAE7FF',
                  '#7FC9FE',
                  '#BAE7FF',
                  '#7FC9FE',
                  '#BAE7FF',

                  '#ABF5F5',
                  '#71E3E3',
                  '#ABF5F5',
                  '#71E3E3',

                  '#BAF5C4',
                  '#8EE0A1',
                ],
              ]}
              tooltip={[
                'kind*percent',
                (item, percent) => {
                  percent = `${(percent * 100).toFixed(2)}%`;
                  return {
                    kind: item,
                    value: percent,
                  };
                },
              ]}
              style={{
                lineWidth: 1,
                stroke: '#fff',
              }}
              select={false}
            >
              <Label content="kind" />
            </Geom>
          </View>
        </Chart>
      </div>
    );
  }
}

export default TestPage;



// WEBPACK FOOTER //
// ./src/routes/TestPage.js